/**
 * 防抖原理：一定时间内，只有最后一次操作，再过wait毫秒后才执行函数
 */
let timeout = null;
const debounce = (func, wait = 500, immediate = false) => {
  // 清除定时器
  if (timeout !== null) clearTimeout(timeout);
  // 立即执行，此类情况一般用不到
  if (immediate) {
    const callNow = !timeout;
    timeout = setTimeout(() => {
      timeout = null;
    }, wait);
    if (callNow) typeof func === "function" && func();
  } else {
    // 设置定时器，当最后一次操作后，timeout不会再被清除，所以在延时wait毫秒后执行func回调方法
    timeout = setTimeout(() => {
      typeof func === "function" && func();
    }, wait);
  }
};

// 节流原理：在一定时间内，只能触发一次
let timer, flag;
const throttle = (func, wait = 500, immediate = true) => {
  if (immediate) {
    if (!flag) {
      flag = true;
      // 如果是立即执行，则在wait毫秒内开始时执行
      typeof func === "function" && func();
      timer = setTimeout(() => {
        flag = false;
      }, wait);
    }
  } else if (!flag) {
    flag = true;
    // 如果是非立即执行，则在wait毫秒内的结束处执行
    timer = setTimeout(() => {
      flag = false;
      typeof func === "function" && func();
    }, wait);
  }
};

// 时间转为毫秒
const timeToSec = time => {
  const reverseTime = time.split(":").reverse();
  var hour = reverseTime[2] ? reverseTime[2] : 0;
  var min = reverseTime[1] ? reverseTime[1] : 0;
  var sec = reverseTime[0] ? reverseTime[0] : 0;
  var s = Number(hour * 3600) + Number(min * 60) + Number(sec);
  return parseInt(s * 1000);
};

// 将秒转化成时分秒
const secTotime = s => {
  let t = "";
  if (s > -1) {
    const hour = Math.floor(s / 3600);
    const min = Math.floor(s / 60) % 60;
    const sec = s % 60;
    if (hour > 0 && hour < 10) {
      t = "0" + hour + ":";
    } else if (hour >= 10) {
      t = hour + ":";
    }
    if (min > 0 && min < 10) {
      t += "0" + min + ":";
    } else if (min >= 10) {
      t += min + ":";
    } else {
      t += "00:";
    }
    if (sec > 0 && sec < 10) {
      t += "0" + parseInt(sec);
    } else if (sec >= 10) {
      t += parseInt(sec);
    } else {
      t += "00";
    }
  }
  return t;
};

// 判断移动端
const env = () => {
  const ENV = {};
  const userAgent = navigator.userAgent;
  ENV.inMobile = !!userAgent.match(/applewebkit.*mobile.*/i); // 移动终端
  ENV.inAndroid = !!userAgent.match(/(Android);?[\s\/]+([\d.]+)?/); // android终端
  ENV.iniPad = !!(
    navigator.userAgent.match(/(iPad)/) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  ); // iPad终端
  ENV.inMac = !!userAgent.match(/(Mac\sOS)\sX\s([\d_]+)/); // iMac终端
  ENV.iniPhone = !!(!ENV.iniPad && userAgent.match(/(iPhone\sOS)\s([\d_]+)/)); // iPhone终端
  ENV.inIOS = ENV.iniPad || ENV.inMac || ENV.iniPhone; // ios终端
  ENV.inSamsung = userAgent.toUpperCase().indexOf("SAMSUNG-SM-N7508V") != -1;

  ENV.inWeichat = userAgent.match(/MicroMessenger/i) != null; // 微信内部浏览器
  ENV.inSafari = userAgent.indexOf("Safari") != -1; // Safari
  ENV.inChrome = !!(
    userAgent.match(/Chrome/i) != null &&
    userAgent.match(/Version\/\d+\.\d+(\.\d+)?\sChrome\//i) == null
  );
  ENV.inQQBrowser = !!userAgent.match(/MQQBrowser\/([\d\.]+)/); // QQ浏览器
  ENV.inUCBrowser = !!userAgent.match(/UCBrowser\/([\d\.]+)/);
  ENV.inIE = userAgent.match(/Trident/i) != null; // IE内核
  ENV.inOpera = userAgent.match(/Presto/i) != null; // opera内核
  ENV.inWebKit = userAgent.match(/Applewebkit/i) != null; // 苹果、谷歌内核
  ENV.inFireFox =
    userAgent.match(/Gecko/i) != null && userAgent.match(/khtml/i) != null; // 火狐内核
  return ENV;
};
const objectReset = (list, key) => {
  const result = [];
  const obj = {};
  for (let i = 0; i < list.length; i++) {
    if (!obj[list[i][key]]) {
      result.push(list[i]);
      obj[list[i][key]] = true;
    }
  }
  return result;
};

// 判断是否空对象
const isEmpty = obj =>
  Reflect.ownKeys(obj).length === 0 && obj.constructor === Object;

// 在指定el后插入html代码或文字
const insertHTMLAfter = (html, el) => el.insertAdjacentHTML("afterend", html);

// 获取选定的文本
const getSelectedText = () => window.getSelection().toString();

// 深拷贝
const deepClone = (obj) => {
  // 变量先置空
  let newobj = null;

  // 判断是否需要继续进行递归
  if (typeof (obj) === 'object' && obj !== null) {
    newobj = obj instanceof Array ? [] : {};
    // 进行下一层递归克隆
    for (var i in obj) {
      newobj[i] = deepClone(obj[i]);
    }
    // 如果不是对象直接赋值
  } else newobj = obj;

  return newobj;
};

export default {
  debounce,
  throttle,
  secTotime,
  timeToSec,
  env,
  objectReset,
  isEmpty,
  insertHTMLAfter,
  getSelectedText,
  deepClone,
};
